module.exports = __webpack_public_path__ + "img/default-pic.0b65ac34.svg";